import { SVG, SVGProps } from './svg'

export function IconNote(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        d="M11.5 13a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9ZM11.5 16a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6ZM9 7h14a2 2 0 0 1 2 2v10.2c0 .5-.2 1-.6 1.4l-3.8 3.8a2 2 0 0 1-1.4.6H9a2 2 0 0 1-2-2V9c0-1.1.9-2 2-2Zm14 1H9a1 1 0 0 0-1 1v14c0 .6.4 1 1 1h10v-3c0-1.1.9-2 2-2h3V9c0-.6-.4-1-1-1Zm.6 12L20 23.6V21c0-.6.4-1 1-1h2.6Z"
      />
    </SVG>
  )
}
